import { useParams } from 'react-router';
import {
  selectGroup,
  selectGroupGuid,
  selectIncidentGuid,
  selectIncidents,
  selectUserGuid,
  selectUserItemId,
  useAppSelector,
} from '../../../slices/commonSelectors';
import { useIncidentScopeId } from './incidentScope';

export const useGroupGuid = () => {
  return useAppSelector(selectGroupGuid);
};

export const useUserGuid = () => {
  return useAppSelector(selectUserGuid);
};

export const useUserItemId = () => {
  return useAppSelector(selectUserItemId);
};

export const useCurrentGroup = () => {
  return useAppSelector(selectGroup);
};

export const useActualIncidentId = () => {
  const scopedIncidentId = useIncidentScopeId();
  const { incidentId } = useParams<{ incidentId: string }>();
  const incident_guid = useAppSelector(selectIncidentGuid);
  return scopedIncidentId ?? incidentId ?? incident_guid;
};

export const useCurrentIncident = () => {
  const incidentId = useActualIncidentId();
  const incidents = useAppSelector(selectIncidents);
  const areIncidentsLoaded = useAppSelector(
    (state) => state.app.areIncidentsLoaded
  );

  return {
    data: incidents.find((incident) => incident.id === incidentId),
    isLoading: !areIncidentsLoaded,
    isError: false,
    error: undefined,
  };
};
